// components/Toast.tsx
import { motion } from 'framer-motion';
import { Rings } from 'react-loader-spinner';

type ToastType = 'success' | 'error' | 'info' | 'loading';

interface ToastProps {
  message: string;
  type: ToastType;
}

const typeClasses: Record<ToastType, string> = {
  success: 'bg-green-800 text-white',
  error: 'bg-red-500 text-white',
  info: 'bg-blue-900 text-white',
  loading: 'bg-gray-700 text-white',
};

const typeIcons = {
  success: '✅',
  error: '❌',
  info: 'ℹ️',
};

const Toast: React.FC<ToastProps> = ({ message, type }) => {
  return (
    // @ts-ignore
    <motion.div
      layout
      initial={{ opacity: 0, y: -50, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: -50, scale: 0.9 }}
      transition={{ duration: 0.3, type: 'spring' }}
      className={`p-4 rounded-lg shadow-lg flex items-center space-x-3 ${typeClasses[type]}`}
    >
      {type === 'loading' ? (
        <Rings
          visible={true}
          height="20"
          width="20"
          color="white"
          ariaLabel="loading-spinner"
        />
      ) : (
        <span className="text-xl">{typeIcons[type]}</span>
      )}
      <p className="font-semibold">{message}</p>
    </motion.div>
  );
};

export default Toast;